export const OVERFLOW_CLASS_NAME = 'overflow-hide';
